import { addMinutes } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

import { dateTimeFormats } from "../conts/dateTimeFormats";
import { SLOT_SIZE } from "../conts/sessionConsts";

export const getSessionEndAt = (startAt: string, timezone: string) => {
  const endAt = addMinutes(startAt, parseInt(SLOT_SIZE));
  return formatInTimeZone(endAt, timezone, dateTimeFormats.dateWithTz);
};
